import { Box } from '@mui/material'

type RichTextBoxProps = {
  htmlContent: string | null | undefined
}

export function RichTextBox(props: RichTextBoxProps) {
  const { htmlContent } = props
  return (
    <Box
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: htmlContent ?? '' }}
      sx={[
        {
          h2: {
            fontSize: 26,
            fontWeight: 300,
            marginTop: '25px',
            marginBottom: '20px',
          },
          h3: {
            fontSize: 18,
            fontWeight: 600,
            marginTop: '20px',
            marginBottom: '10px',
          },
          p: {
            fontSize: 16,
            lineHeight: '24px',
            fontWeight: 400,
            marginBottom: '10px',
          },
        },
      ]}
    />
  )
}
